import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';


import {AuthenticationService} from '../../../services/authentication.service';
import {AppConfig} from '../../../app.config';

@Component({
  templateUrl: 'reset-password-init.component.html'
})
export class ResetPasswordInitComponent implements OnInit {

  private _email: string;

  private _infoMessage: string;

  private _errorMessage: string;

  constructor(private route: ActivatedRoute,
              private authService: AuthenticationService
  ) {

  }

  ngOnInit(): void {
    this._email = '';
    this.route.queryParams.subscribe((params: Params) => {
      this._email = params['email'];
    });

  }

  submit(): void {

    console.log('email: ' + this._email);


    this.authService.post(AppConfig.UAA_URL + '/api/account/reset-password/init', this._email)
      .subscribe({
        next: (value) => {
          this._infoMessage = 'Request to reset password successful. Please check your email: ' + this._email;
          this._errorMessage = '';
        },
        error: (error) => {
          this._errorMessage = 'Unable to do password reset, make sure the account with email ' + this._email + ' exists.';
          this._infoMessage = '';
        }
      });


  }

  set email(value: string) {
    this._email = value;
  }

  get email(): string {
    return this._email;
  }

  get infoMessage(): string {
    return this._infoMessage;
  }

  get errorMessage(): string {
    return this._errorMessage;
  }
}
